(function ($) {
	$(document).ready(function () {
		/* Get the URL Parameter */
		function getURLParameter(sParam) {
			var sPageURL = window.location.search.substring(1);
			var sURLVariables = sPageURL.split("&");
			for (var i = 0; i < sURLVariables.length; i++) {
				var sParameterName = sURLVariables[i].split("=");
				if (sParameterName[0] == sParam) {
					return sParameterName[1];
				}
			}
		}

		let categoryValue = getURLParameter("pillar");

		/* If there is a category selected (in the URL) then filter the list */
		if (categoryValue) {
			$("#" + categoryValue).addClass("active");
		}

		let url = $(location).attr("href"),
			parts = url.split("/"),
			last_part = parts[parts.length - 2];

		if (last_part) {
			$("#" + last_part).addClass("active");
		}
	});
})(jQuery);
